// "Pošlji dokumente" — the popup behind every .js-send-documents button
// (common/_send_documents_button). The button says where to post and which
// addresses we already know; everything else is here, so the report screen and
// the admin's actions get the same dialog without either page knowing how it
// works.
//
// Bound on the document, not on the buttons: both pages render the button once
// at load, but binding this way means a button added later still works.

var sendDocuments = {
  // The addresses go in a textarea, not an <input type=email>: people paste a
  // list out of a mail client, separators and all. The server is what decides
  // which of them are addresses (MatchDocumentsController#parse_emails) and it
  // answers with the ones it accepted, so a dropped typo is visible.
  body: function(known) {
    var body = "<p>Zapisnik, poročilo in seznama strelcev gredo kot priloge na naslove, ki jih vpišeš. "
             + "Naslovniki se med sabo ne vidijo.</p>";

    if(known && known.length) {
      body += "<p class='eyebrow mb-1'>Znani naslovi</p><p class='report-invite__known'>";
      for(var i = 0; i < known.length; i++) {
        body += "<button type='button' class='btn btn-sm btn-outline-secondary mr-1 mb-1 js-add-doc-email' data-email='" + known[i][1] + "'>"
              + known[i][0] + ": " + known[i][1] + "</button>";
      }
      body += "</p>";
    }

    body += "<label class='field field--wide'><span class='eyebrow'>E-naslovi</span>"
          + "<textarea class='form-control' id='send-docs-emails' rows='3' placeholder='ime@primer.si, drugi@primer.si'></textarea></label>"
          + "<p class='mt-3 mb-0'><button type='button' class='btn btn-primary' id='send-docs-send'>Pošlji dokumente</button></p>";
    return body;
  },

  init: function() {
    $(document).on('click', '.js-send-documents', function() {
      var $btn = $(this);
      sendDocuments.url = $btn.data('url');

      alerts.show({
        title: 'Pošlji dokumente o tekmi',
        type: 'info',
        body: sendDocuments.body($btn.data('emails') || [])
      });
    });

    // a shortcut appends rather than replaces: the usual case is several clubs
    $(document).on('click', '.js-add-doc-email', function() {
      var $field = $('#send-docs-emails');
      var current = ($field.val() || '').trim();
      var email = $(this).data('email');
      if(current.indexOf(email) >= 0) return;

      $field.val(current ? current + ', ' + email : email).focus();
    });

    $(document).on('click', '#send-docs-send', function() {
      var $btn = $(this);
      var emails = ($('#send-docs-emails').val() || '').trim();
      if(!emails) return;

      $btn.prop('disabled', true).text('Pošiljam…');
      $.ajax(sendDocuments.url, {
        method: 'POST',
        // PDFs may still have to be rendered for a match that is not finished
        timeout: 60000,
        data: { emails: emails },
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        success: function(data) {
          $btn.closest('.modal').modal('hide');
          alerts.info('Poslano', "<p>Dokumenti so na poti na <b>" + (data.recipients || []).join('</b>, <b>') + "</b>.</p>");
        },
        error: function(xhr, status, msg) {
          console.error(status, msg, xhr);
          $btn.prop('disabled', false).text('Pošlji dokumente');
          var reason = (xhr.responseJSON || {}).message || 'Poskusi znova.';
          alerts.warning("<p>Dokumentov ni bilo mogoče poslati. " + reason + "</p>");
        }
      });
    });
  }
};

global.sendDocuments = sendDocuments;
$(function() { sendDocuments.init(); });
